export function SET_STRAIN_LIST(state, strains) {
  state.strainsList = strains;
}

export function SET_BIOACTIVE_BANK_STRAINS_LIST(state, strains) {
  state.bioactiveBankStrains = strains;
}